import * as React from 'react';
import { observer } from 'mobx-react-lite';
import AppPaneUnderlay from './AppPaneUnderlay';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { AppPaneUnderlayViewState } from '../store/store';

let styles = require('./App.css');

export interface AppProps {
    renderHeader: () => React.ReactElement<{}>;
    children?: React.ReactNode;
    renderSkipLinkPlaceholder?: () => React.ReactElement<{}>;
    underlay?: AppPaneUnderlayViewState;
}

export default observer(function App({
    renderHeader,
    children,
    renderSkipLinkPlaceholder,
    underlay,
}: AppProps) {
    return (
        <Fabric className={styles.appContainer}>
            {renderSkipLinkPlaceholder?.()}
            {renderHeader()}
            <div className={styles.main}>
                {children}
                <AppPaneUnderlay underlay={underlay} />
            </div>
        </Fabric>
    );
});
